<template>
  <div>
    <van-popup
        v-model="showNormalPopup"
        position="center"
        round
        @close="cancel"
    >
      <div class="visit-popup">
        <van-form ref="formRef">
          <!-- 探访对象单选框 -->
          <div class="form-item">
            <div class="form-label">探访对象:</div>
            <van-radio-group v-model="form_data.visitType" class="custom-radio-group">
              <template v-for="item in visit_type_list">
                <van-radio :name="item.value" class="inline-radio">{{ item.title }}</van-radio>
              </template>
            </van-radio-group>
          </div>

          <!-- 探访时间选择 -->
          <div class="form-item">
            <div class="form-label"><span class="form-label-required">*</span>探访时间:</div>
            <van-field
                :rules="[{required: true }]"
                class="time-picker"
                name="visitTime"
                v-model="form_data.visitTime"
                placeholder="请选择探访时间"
                readonly
                @click="showDatePickerPopup"
            />
          </div>

          <!-- 探访内容文本域 -->
          <div class="form-item">
            <div class="form-label"><span class="form-label-required">*</span>探访内容:</div>
            <van-field
                v-model="form_data.content"
                :rules="[{required: true }]"
                class="content-input"
                type="textarea"
                name="content"
                rows="8"
                maxlength="1000"
                placeholder="请输入探访内容"
                show-word-limit
            />
          </div>
        </van-form>
        <!-- 按钮 -->
        <div class="form-item form-item2">
          <!--取消按钮-->
          <div class="form-cancel">
            <van-button type="primary" color="#5f5aa1" @click="cancel">取消</van-button>
          </div>
          <!--提交按钮-->
          <div class="form-submit">
            <van-button type="primary" color="#5f5aa1" @click="ok">提交探访</van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 日期选择器弹窗 -->
    <van-popup v-model="showDatePicker" position="bottom" :style="{ height: '360px' }">
      <van-datetime-picker
          type="date"
          v-model="currentDate"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="handleDateConfirm"
          @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>

</template>

<script>
import { CRM_API } from '@/request/crm';
import TYPES from "@/constant/types";
import { visitAdd } from "@/request/visit_survery";
import dayjs from "dayjs";
import Vue from "vue";

export default {
  name: "index",
  components: {},
  props: {
    visitList: {
      type: [Array],
      default: () => []
    },
    showNormalPopup: {
      type: [Boolean],
      default: false
    },
    hospitalId: {
      type: [String],
      default: ""
    },
    patientId: {
      type: [String],
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2100, 10, 1),
      currentDate: new Date(),
      showDatePicker: false,
      visit_type_list: [],
      form_data: {
        visitType: "1",
        visitTime: "",
        content: "",
        patientId: "",
        hospitalId: ""
      }
    };
  },
  created() {
    this.visit_type_list = Vue.ls.get(TYPES.UI_CACHE_DB_DICT_DATA)["visit_type"];
  },
  methods: {
    handleDateConfirm(date) {
      const { form_data } = this
      // 格式化日期为 YYYY-MM-DD
      form_data.visitTime = dayjs(date).format("YYYY-MM-DD");
      this.showDatePicker = false;
    },
    showDatePickerPopup() {
      this.showDatePicker = true;
    },
    async ok() {
      const {form_data, hospitalId, patientId, cancel, loading, setLoading, submitTags} = this
      if(loading) {
        return false;
      }

      setLoading(true);
      form_data.hospitalId = hospitalId
      form_data.patientId = patientId
      this.$refs.formRef.validate().then((res) => {
        visitAdd({ ...form_data }).then(res => {
          console.log(res,'=========================');
          setLoading(false);
          submitTags(patientId, form_data.content);
          this.$emit("ok");
          return res;
        })
      }).catch((err) => {
        setLoading(false);
        console.log(err);
      })
    },
    // 提交标签
    async submitTags(patientId, value) {
      const tags = (Vue.ls.get(TYPES.UI_CACHE_DB_DICT_DATA) || {patient_tag: []}).patient_tag
      console.log(tags, '-------------------------')

      const tag = tags.find(tag => tag.text.indexOf(value) !== -1)
      if (!tag) {
        return false;
      }

      const { code } = await CRM_API.crmPatientEditTag({ id: patientId, tag: tag.value })
      if ( code !== 200 ) {
        this.$toast.error('患者标签保存失败！')
        return false
      }
      return true
    },
    setLoading(loading) {
      this.loading = loading;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="less">

.form-item {
  margin-bottom: 50px;
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  .form-label {
    font-size: 28px;
    white-space: nowrap;
    position: relative;
    padding-left: 15px;
    .form-label-required {
      position: absolute;
      color: red;
      left: 0;
      font-weight: bold;
      font-size: 0.8rem;
    }
  }

  .custom-radio-group {
    display: inline-block;

    .inline-radio {
      display: inline-flex;
      align-items: center;
      margin-left: 20px;
    }
  }

  .time-picker {
    width: 260px;
    height: 50px;
    border: 1px solid #1e1f22;
    border-radius: 15px;
    margin-left: 15px;
    margin-top: -5px;
    display: flex;
    justify-content: center;
    align-items: center;

    input.van-field__control {
      font-size: 26px;
      text-align: center;
    }
  }

  .content-input {
    border: 1px solid #1e1f22;
    border-radius: 15px;
    margin-left: 15px;
    margin-top: -5px;
    padding: 14px;

    .van-field__control {
      font-size: 27px;
    }
  }
}

</style>
